<template>
  <div class="context-menu" :style="getContextMenyStyle()">
    <ul>
      <li @mousedown="ComBindleDel" @click="handleMouseUp">删除</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'ComBined',
  data() {
    return {};
  },
  methods: {
    getContextMenyStyle() {
      let { isOpen, position } = this.$store.state.ComBined;
      return {
        display: isOpen ? 'block' : 'none',
        top: position.top + 'px',
        left: position.left + 'px',
      };
    },
    handleMouseUp() {
      this.$store.commit('set_ComBined', {
        isOpen: false,
      });
    },
    ComBindleDel(e) {
      e.stopPropagation();
      this.$store.commit('del_Combo_Box', this.$store.state.CurrentConfigration.id);
    },
  },
  computed: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.context-menu {
  user-select: none;
  position: fixed;
  left: 0;
  top: 0;

  font-size: 12px;
  color: #fff;
  width: 120px;

  background-color: #27343e;
  z-index: 999;
  ul,
  li {
    list-style: none;
    padding: 0;
    margin: 0;
    width: 100%;
  }
  li {
    height: 25px;
    line-height: 25px;
    padding-left: 10px;
    box-sizing: border-box;
    cursor: pointer;
    border-left: 3px solid rgba(204, 204, 204, 0);
    letter-spacing: 1px;
    &:hover {
      background-color: #1b262f;
      color: rgb(0, 140, 255);
      border-left: 3px solid rgb(0, 140, 255);
    }
  }
}
</style>
